import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';
import { TriggerPayload } from '../trigger-payload/trigger-payload';
import { EnrolmentPlacedInInvoicingBatchTriggerMonitor } from './enrolment-placed-in-invoicing-batch-trigger-monitor';
import { TransitionTrigger } from './transition-trigger';

export class EnrolmentPlacedInInvoicingBatchTrigger extends TransitionTrigger {
	public orderingNumber = 60;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Create an invoice batch', excludedEnrolmentStatuses);
	}

	public async triggerTransitions(enrolments: readonly Enrolment[], payload: TriggerPayload = new TriggerPayload()): Promise<void> {
		const step = enrolments[0]?.fulfillmentStep?.fulfillmentStepIndication ?? null;
		const status = enrolments[0]?.status?.value ?? null;
		const monitor = new EnrolmentPlacedInInvoicingBatchTriggerMonitor();
		monitor.start();

		try {
			this.redshiftTracker.trackTransitionInitiated();
			await this.performTransitions(enrolments, payload);
			monitor.commandSucceeded();
			this.redshiftTracker.trackTransitionSpeed(this.name, step, status);
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		} catch (e) {
			monitor.commandFailed();
		}
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentPlacedInInvoicingBatchTrigger;
	}

	protected async performTransitions(enrolments: readonly Enrolment[], payload: TriggerPayload): Promise<void> {
		await EnrolmentService.createInvoicingBatch(enrolments, payload.organisationIdentity);
	}
}
